import { IBusinessAttribute } from '@site-mate/sitemate-global-shared';
import ky, { KyResponse } from 'ky';

import { env } from '@/env';

export abstract class DashpivotApiService {
  static client = ky.create({
    prefixUrl: env.VITE_DASHPIVOT_API_URL,
    headers: {
      'Content-Type': 'application/json',
      'x-sitemate-client': 'gearbelt-web',
    },
    timeout: 20000,
    retry: 0,
  });

  static async getVerticals(): Promise<KyResponse<IBusinessAttribute[]>> {
    return await this.client.get(`business-attributes/verticals`);
  }

  static async getRoles(): Promise<KyResponse<IBusinessAttribute[]>> {
    return await this.client.get(`business-attributes/roles`);
  }

  static async getDisciplines(): Promise<KyResponse<IBusinessAttribute[]>> {
    return await this.client.get(`business-attributes/disciplines`);
  }
}
